export const gateway = "https://qat-scoop-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=2pq2hjjegetmn0hofoibr3330g&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-scoop-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "2pq2hjjegetmn0hofoibr3330g";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://qat-scoop-shopper.link-nonprod.wawanesalife.com";

//updated on Mon Sep 15 2025 17:36:10 GMT+0000 (Coordinated Universal Time)
